export default __webpack_public_path__ + "static/media/edit.26685ac2.svg";